import { MagentoFreeTrialAvailabilitySkuResponse } from '../interfaces/free-trial-availability.interface';

export const mapFreeTrialResponse = (res)  => {
  return {
    freeTrialAvailability: res.free_trial_availability.map((freeTrial: MagentoFreeTrialAvailabilitySkuResponse) => {
      const { term_length: duration, sku, enabled, message } = freeTrial;
      return { duration, enabled, sku, message };
    }),
  };
};
